/**
 * @generated SignedSource<<a4705898155490dc975e592506f98004>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PathwayAdminDropdownFragment$data = {
  readonly id: string;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"usePathwayAdminDropdownItemsFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "PathwayAdminDropdownFragment";
};
export type PathwayAdminDropdownFragment$key = {
  readonly " $data"?: PathwayAdminDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PathwayAdminDropdownFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PathwayAdminDropdownFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePathwayAdminDropdownItemsFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "285e2c82838acc51d8b99a2a3d6196b1";

export default node;
